import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import ProtectedRoute from "components/ProtectedRoute";
// Add your imports here
import Homepage from "pages/homepage";
import ProfileDashboard from "pages/profile-dashboard";
import ProfileSettings from "pages/profile-settings";
import GiftFinder from "pages/gift-finder";
import GiftConcierge from "pages/gift-concierge";
import Occasions from "pages/occasions";
import OccasionCreation from "pages/occasion-creation";
import Wishlists from "pages/wishlists";
import Giveaways from "pages/giveaways";
import About from "pages/about";
import Community from "pages/community";
import GiftIdeasHub from "pages/gift-ideas-hub";
import ArticleDetailPage from "pages/article-detail-page";
import ProductDetailPage from "pages/product-detail-page";
import SharedContentPage from "pages/shared-content-page";
import GiveawayDetailPage from "pages/giveaway-detail-page";
import Login from "pages/Login";
import NotFound from "pages/NotFound";
// Auth components
import RegistrationRedirect from "pages/auth/RegistrationRedirect";
import CountryLanguageSelection from "pages/auth/country-language-selection";
import NameEmailRegistration from "pages/auth/name-email-registration";
import Register from "pages/auth/register";
import BirthdayGenderSelection from "pages/auth/birthday-gender-selection";
import Verify from "pages/auth/verify";
import ForgotPassword from "pages/auth/forgot-password";
import ResetPassword from "pages/auth/reset-password";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Public routes */}
          <Route path="/" element={<Homepage />} />
          <Route path="/homepage" element={<Homepage />} />
          <Route path="/about" element={<About />} />
          <Route path="/community" element={<Community />} />
          <Route path="/gift-ideas-hub" element={<GiftIdeasHub />} />
          <Route path="/article-detail-page" element={<ArticleDetailPage />} />
          <Route path="/products/:productSlug" element={<ProductDetailPage />} />
          <Route path="/product-detail-page" element={<ProductDetailPage />} />
          
          {/* Universal share routes */}
          <Route path="/wishlist/:token" element={<SharedContentPage />} />
          <Route path="/occasion/:token" element={<SharedContentPage />} />
          <Route path="/giveaway/:giveawayId" element={<GiveawayDetailPage />} />

          {/* Authentication routes (redirect if already logged in) */}
          <Route
            path="/login"
            element={
              <ProtectedRoute requireAuth={false}>
                <Login />
              </ProtectedRoute>
            }
          />
          {/* Country and Language Selection */}
          <Route
            path="/country-language-selection"
            element={
              <ProtectedRoute requireAuth={false}>
                <CountryLanguageSelection />
              </ProtectedRoute>
            }
          />
          <Route
            path="/auth/country-language-selection"
            element={
              <ProtectedRoute requireAuth={false}>
                <CountryLanguageSelection />
              </ProtectedRoute>
            }
          />
          {/* Main registration entry points - redirect to country selection or form */}
          <Route
            path="/register"
            element={
              <ProtectedRoute requireAuth={false}>
                <RegistrationRedirect />
              </ProtectedRoute>
            }
          />
          {/* Name and Email Registration (Step 2) */}
          <Route
            path="/name-email-registration"
            element={
              <ProtectedRoute requireAuth={false}>
                <NameEmailRegistration />
              </ProtectedRoute>
            }
          />
          {/* Direct access to registration form (internal route) */}
          <Route
            path="/auth/register"
            element={
              <ProtectedRoute requireAuth={false}>
                <Register />
              </ProtectedRoute>
            }
          />
          {/* Forgot Password */}
          <Route
            path="/forgot-password"
            element={
              <ProtectedRoute requireAuth={false}>
                <ForgotPassword />
              </ProtectedRoute>
            }
          />
          {/* Reset Password */}
          <Route
            path="/reset-password"
            element={
              <ProtectedRoute requireAuth={false}>
                <ResetPassword />
              </ProtectedRoute>
            }
          />
          <Route
            path="/auth/birthday-gender-selection"
            element={
              <ProtectedRoute requireAuth={false}>
                <BirthdayGenderSelection />
              </ProtectedRoute>
            }
          />
          <Route
            path="/auth/verify"
            element={
              <ProtectedRoute requireAuth={false}>
                <Verify />
              </ProtectedRoute>
            }
          />
          <Route
            path="/auth/forgot-password"
            element={
              <ProtectedRoute requireAuth={false}>
                <ForgotPassword />
              </ProtectedRoute>
            }
          />
          <Route
            path="/auth/reset-password"
            element={
              <ProtectedRoute requireAuth={false}>
                <ResetPassword />
              </ProtectedRoute>
            }
          />

          {/* Protected routes (require authentication) */}
          <Route
            path="/profile-dashboard"
            element={
              <ProtectedRoute>
                <ProfileDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <ProfileDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile-settings"
            element={
              <ProtectedRoute>
                <ProfileSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/gift-finder"
            element={
              <ProtectedRoute>
                <GiftFinder />
              </ProtectedRoute>
            }
          />
          <Route
            path="/gift-concierge"
            element={
              <ProtectedRoute>
                <GiftConcierge />
              </ProtectedRoute>
            }
          />
          <Route
            path="/occasions"
            element={
              <ProtectedRoute>
                <Occasions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/occasion-creation"
            element={
              <ProtectedRoute>
                <OccasionCreation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/wishlists"
            element={
              <ProtectedRoute>
                <Wishlists />
              </ProtectedRoute>
            }
          />
          <Route
            path="/giveaways"
            element={
              <ProtectedRoute>
                <Giveaways />
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;